import { __awaiter, __generator, __values } from "tslib";
import { TransactionMode, } from '@tencent/memoire-core';
import { convertPersistentDataToModel, convertModelToPersistentData } from '../utils/model-data-converter';
import StructuredCollectionSlice from './structured-collection-slice';
var StructuredCollection = /** @class */ (function () {
    function StructuredCollection(name, options) {
        this.name = name;
        this.aspects = options.aspects;
        this.contextGenerator = options.contextGenerator;
        this.unsliced = new StructuredCollectionSlice(name, options);
        this.patch();
    }
    StructuredCollection.prototype.skip = function (offset) {
        return this.unsliced.clone().skip(offset);
    };
    StructuredCollection.prototype.take = function (limit) {
        return this.unsliced.clone().take(limit);
    };
    StructuredCollection.prototype.slice = function (start, end) {
        return this.unsliced.clone().slice(start, end);
    };
    StructuredCollection.prototype.orderBy = function (path, order) {
        return this.unsliced.clone().orderBy(path, order);
    };
    StructuredCollection.prototype.where = function (descriptor) {
        return this.unsliced.clone().where(descriptor);
    };
    StructuredCollection.prototype.or = function (descriptor) {
        return this.unsliced.clone().or(descriptor);
    };
    StructuredCollection.prototype.update = function (updater) {
        return this.unsliced.update(updater);
    };
    StructuredCollection.prototype.clear = function () {
        return this.unsliced.clear();
    };
    StructuredCollection.prototype.count = function () {
        return this.unsliced.count();
    };
    StructuredCollection.prototype.entries = function () {
        return this.unsliced.entries();
    };
    StructuredCollection.prototype.keys = function () {
        return this.unsliced.keys();
    };
    StructuredCollection.prototype.values = function () {
        return this.unsliced.values();
    };
    StructuredCollection.prototype.first = function () {
        return this.unsliced.first();
    };
    StructuredCollection.prototype.last = function () {
        return this.unsliced.last();
    };
    StructuredCollection.prototype.get = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            var _this = this;
            return __generator(this, function (_a) {
                context = this.contextGenerator.spawnContext();
                return [2 /*return*/, context.perform(function () { return __awaiter(_this, void 0, void 0, function () {
                        var model, transaction, table, data;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, context.waitForModelRegistered(this.name)];
                                case 1:
                                    model = _a.sent();
                                    return [4 /*yield*/, context.getTransactionGenerator([this.name], TransactionMode.READ_ONLY)];
                                case 2:
                                    transaction = (_a.sent()).startTransaction();
                                    table = transaction.table(this.name);
                                    return [4 /*yield*/, table.get(key)];
                                case 3:
                                    data = _a.sent();
                                    return [2 /*return*/, data ? convertPersistentDataToModel(data, model.class) : null];
                            }
                        });
                    }); })];
            });
        });
    };
    StructuredCollection.prototype.has = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            var _this = this;
            return __generator(this, function (_a) {
                context = this.contextGenerator.spawnContext();
                return [2 /*return*/, context.perform(function () { return __awaiter(_this, void 0, void 0, function () {
                        var transaction, table, cursor;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, context.getTransactionGenerator([this.name], TransactionMode.READ_ONLY)];
                                case 1:
                                    transaction = (_a.sent()).startTransaction();
                                    table = transaction.table(this.name);
                                    return [4 /*yield*/, table.openCursor(key)];
                                case 2:
                                    cursor = _a.sent();
                                    return [2 /*return*/, !!cursor];
                            }
                        });
                    }); })];
            });
        });
    };
    StructuredCollection.prototype.delete = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            var _this = this;
            return __generator(this, function (_a) {
                context = this.contextGenerator.spawnContext();
                return [2 /*return*/, context.perform(function () { return __awaiter(_this, void 0, void 0, function () {
                        var transaction, table, cursor;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, context.getTransactionGenerator([this.name], TransactionMode.READ_WRITE)];
                                case 1:
                                    transaction = (_a.sent()).startTransaction();
                                    table = transaction.table(this.name);
                                    return [4 /*yield*/, table.openCursor(key)];
                                case 2:
                                    cursor = _a.sent();
                                    return [4 /*yield*/, table.delete(key)];
                                case 3:
                                    _a.sent();
                                    return [2 /*return*/, cursor ? key : null];
                            }
                        });
                    }); })];
            });
        });
    };
    StructuredCollection.prototype.insert = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            var _this = this;
            return __generator(this, function (_a) {
                context = this.contextGenerator.spawnContext();
                return [2 /*return*/, context.perform(function () { return __awaiter(_this, void 0, void 0, function () {
                        var transaction, table, key;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, context.getTransactionGenerator([this.name], TransactionMode.READ_WRITE)];
                                case 1:
                                    transaction = (_a.sent()).startTransaction();
                                    table = transaction.table(this.name);
                                    return [4 /*yield*/, table.insert(convertModelToPersistentData(item))];
                                case 2:
                                    key = _a.sent();
                                    return [2 /*return*/, key];
                            }
                        });
                    }); })];
            });
        });
    };
    StructuredCollection.prototype.upsert = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            var _this = this;
            return __generator(this, function (_a) {
                context = this.contextGenerator.spawnContext();
                return [2 /*return*/, context.perform(function () { return __awaiter(_this, void 0, void 0, function () {
                        var transaction, table, key;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, context.getTransactionGenerator([this.name], TransactionMode.READ_WRITE)];
                                case 1:
                                    transaction = (_a.sent()).startTransaction();
                                    table = transaction.table(this.name);
                                    return [4 /*yield*/, table.upsert(convertModelToPersistentData(item))];
                                case 2:
                                    key = _a.sent();
                                    return [2 /*return*/, key];
                            }
                        });
                    }); })];
            });
        });
    };
    StructuredCollection.prototype.bulkInsert = function (items) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            var _this = this;
            return __generator(this, function (_a) {
                context = this.contextGenerator.spawnContext();
                return [2 /*return*/, context.perform(function () { return __awaiter(_this, void 0, void 0, function () {
                        var transaction, keys, table, items_1, items_1_1, item, key, e_1_1;
                        var e_1, _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, context.getTransactionGenerator([this.name], TransactionMode.READ_WRITE)];
                                case 1:
                                    transaction = (_b.sent()).startTransaction();
                                    keys = [];
                                    table = transaction.table(this.name);
                                    _b.label = 2;
                                case 2:
                                    _b.trys.push([2, 7, 8, 9]);
                                    items_1 = __values(items), items_1_1 = items_1.next();
                                    _b.label = 3;
                                case 3:
                                    if (!!items_1_1.done) return [3 /*break*/, 6];
                                    item = items_1_1.value;
                                    return [4 /*yield*/, table.insert(convertModelToPersistentData(item))];
                                case 4:
                                    key = _b.sent();
                                    keys.push(key);
                                    _b.label = 5;
                                case 5:
                                    items_1_1 = items_1.next();
                                    return [3 /*break*/, 3];
                                case 6: return [3 /*break*/, 9];
                                case 7:
                                    e_1_1 = _b.sent();
                                    e_1 = { error: e_1_1 };
                                    return [3 /*break*/, 9];
                                case 8:
                                    try {
                                        if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
                                    }
                                    finally { if (e_1) throw e_1.error; }
                                    return [7 /*endfinally*/];
                                case 9: return [2 /*return*/, keys];
                            }
                        });
                    }); })];
            });
        });
    };
    StructuredCollection.prototype.bulkUpsert = function (items) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            var _this = this;
            return __generator(this, function (_a) {
                context = this.contextGenerator.spawnContext();
                return [2 /*return*/, context.perform(function () { return __awaiter(_this, void 0, void 0, function () {
                        var transaction, table;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, context.getTransactionGenerator([this.name], TransactionMode.READ_WRITE)];
                                case 1:
                                    transaction = (_a.sent()).startTransaction();
                                    table = transaction.table(this.name);
                                    return [2 /*return*/, table.bulkUpsert(items.map(function (item) { return convertModelToPersistentData(item); }))];
                            }
                        });
                    }); })];
            });
        });
    };
    StructuredCollection.prototype.conditions = function () {
        return this.unsliced.conditions();
    };
    StructuredCollection.prototype.patch = function () {
        this.aspects.get.patch(this, 'get');
        this.aspects.has.patch(this, 'has');
        this.aspects.delete.patch(this, 'delete');
        this.aspects.insert.patch(this, 'insert');
        this.aspects.upsert.patch(this, 'upsert');
        this.aspects.bulkInsert.patch(this, 'bulkInsert');
        this.aspects.bulkUpsert.patch(this, 'bulkUpsert');
    };
    return StructuredCollection;
}());
export default StructuredCollection;
//# sourceMappingURL=structured-collection.js.map